import GetCurrentAppConfig from "@/actions/config/get-current-app-config";
import { mainFooterConfig } from "@/config/main";
import Image from "next/image";
import Link from "next/link";
import { v4 } from "uuid";

const MainFooter = () => {
  const socials = GetCurrentAppConfig().socials;
  const APP_ID = process.env.NEXT_PUBLIC_APP_ID;

  return (
    <footer
      className="mt-4 border-t border-gray-900/10 shadow-sm dark:border-white"
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto max-w-7xl px-6 pb-8 lg:px-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="mt-4 grid grid-cols-2 gap-8 xl:col-span-2">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              {APP_ID === "learn" && (
                <div>
                  <Image
                    src={"/images/learn.png"}
                    alt=""
                    width={200}
                    height={200}
                  />
                </div>
              )}
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div className="md:mt-0">
                <h3 className="text-heading text-sm font-semibold leading-6">
                  Pages
                </h3>
                <ul role="list" className="mt-6 space-y-4">
                  {mainFooterConfig.pages.map((page) => (
                    <li key={v4()}>
                      <Link
                        href={page.slug}
                        className="text-sm leading-6 text-muted-foreground"
                      >
                        {page.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="xs:mt-4 md:mt-0">
                <h3 className="text-heading text-sm font-semibold leading-6">
                  Legal
                </h3>
                <ul role="list" className="mt-6 space-y-4">
                  {mainFooterConfig.legals.map((legal) => (
                    <li key={v4()}>
                      <Link
                        href={legal.slug}
                        className="text-sm leading-6 text-muted-foreground"
                      >
                        {legal.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4 border-t border-gray-900/10 md:flex md:items-center md:justify-between">
          <div className="flex justify-end space-x-6 pt-4 md:order-2 md:justify-start">
            {socials.map((item) => (
              <a
                key={item.name}
                href={item.url}
                className="text-muted-foreground"
              >
                <span className="sr-only">{item.name}</span>
                <item.icon className="h-6 w-6" aria-hidden="true" />
              </a>
            ))}
          </div>
          <p className="pt-4 text-sm leading-5 text-muted-foreground md:order-1 md:mt-0">
            Made with ♥️
            <br />
            {mainFooterConfig.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default MainFooter;
